import api from './api';

export const reportService = {
  async getWeeklyReport(employeeId, weekStart, weekEnd, filters = {}) {
    const response = await api.get('/reports/weekly', {
      params: {
        employeeId,
        weekStart,
        weekEnd,
        customerId: filters.customerId || undefined,
        clientId: filters.clientId || undefined,
        priority: filters.priority || undefined,
        categoryId: filters.categoryId || undefined
      }
    });
    return response.data;
  },

  async updateWeeklyNotes(payload) {
    const response = await api.put('/reports/weekly/notes', payload);
    return response.data;
  },

  async exportWeeklyReport(employeeId, weekStart, weekEnd, filters = {}) {
    const response = await api.get('/reports/weekly/export', {
      params: {
        employeeId,
        weekStart,
        weekEnd,
        customerId: filters.customerId || undefined,
        clientId: filters.clientId || undefined,
        priority: filters.priority || undefined,
        categoryId: filters.categoryId || undefined,
        format: 'csv'
      },
      responseType: 'blob'
    });
    return response;
  },

  async sendWeeklyDigestNow(payload) {
    const response = await api.post('/reports/weekly/digest/send-now', payload);
    return response.data;
  }
};
